import { useEffect } from "react";

/**
 * Global keyboard shortcut. `combo` is "mod+k" style: `mod` is Ctrl on
 * Windows/Linux and Cmd on macOS. The handler runs even while an input has
 * focus, because a launcher shortcut must work from anywhere.
 */
export function useHotkey(combo: string, handler: (event: KeyboardEvent) => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const parts = combo.toLowerCase().split("+");
    const key = parts[parts.length - 1];
    const needMod = parts.includes("mod");
    const needShift = parts.includes("shift");
    const needAlt = parts.includes("alt");
    const onKey = (event: KeyboardEvent) => {
      if (event.key.toLowerCase() !== key) return;
      if (needMod !== (event.ctrlKey || event.metaKey)) return;
      if (needShift !== event.shiftKey || needAlt !== event.altKey) return;
      event.preventDefault();
      handler(event);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [combo, handler, enabled]);
}
